
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 726.095 346.995"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.151 0h677.791c13.339 0 24.153 12.417 24.153 27.734v291.53c0 15.315-10.814 27.731-24.153 27.731H24.151C10.813 346.995 0 334.579 0 319.264V27.733C0 12.417 10.814 0 24.151 0z","fill":"#ed2224"}}),_c('g',{attrs:{"fill":"#fff"}},[_c('path',{attrs:{"d":"M253.985 203.423l-51.508-30.362c-10.844-6.142-19.434-14.639-25.754-25.483-6.328-10.844-9.488-22.585-9.488-35.242 0-19.519 6.862-36.14 20.603-49.881 13.733-13.732 30.363-20.603 49.881-20.603 24.576 0 48.797 3.439 72.653 10.302L296.275 93.36c-19.163-5.422-38.682-8.133-58.556-8.133-7.591 0-14.012 2.626-19.248 7.862-5.244 5.244-7.862 11.657-7.862 19.248 0 10.488 4.516 18.256 13.555 23.314l51.508 30.363c11.564 6.506 20.781 15.639 27.651 27.381 6.862 11.75 10.302 24.491 10.302 38.224 0 20.968-7.413 38.859-22.229 53.677-14.826 14.825-32.718 22.229-53.677 22.229-32.531 0-63.8-5.6-93.798-16.808l13.555-41.207c25.661 9.76 52.406 14.64 80.244 14.64 9.031 0 16.715-3.16 23.043-9.488 6.32-6.319 9.488-14.004 9.488-23.043 0-12.285-5.422-21.689-16.266-28.196zM468.779 85.227l-3.795 45.544c6.141-1.44 12.283-2.169 18.434-2.169 23.855 0 44.273 8.497 61.268 25.483 16.986 16.994 25.482 37.411 25.482 61.267s-8.496 44.281-25.482 61.267c-16.994 16.994-37.412 25.483-61.268 25.483-4.338 0-8.861-.356-13.555-1.085l-61.268-9.759 3.254-43.375 64.52 10.302c2.525.364 4.881.542 7.049.542 11.928 0 22.137-4.151 30.633-12.47 8.49-8.312 12.742-18.613 12.742-30.905 0-12.284-4.252-22.585-12.742-30.905-8.496-8.311-18.705-12.47-30.633-12.47h-65.063l10.844-130.125h130.125v43.375h-90.545z"}})])])
          )
        }
      }
    